import React, { Fragment, useEffect, useState, useMemo } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import API from "../../../api/baseApi";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const GetInTouch = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const client = useSelector((state) => state.clients.selectedClient?.value);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await API.get("/customers/getInTouch");
      if (res.data?.success) {
        setData(res.data.data || []);
      } else {
        toast.error("Failed to fetch get-in-touch records");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error fetching get-in-touch records");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [client]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Name",
        size: 150,
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 200,
      },
      {
        accessorKey: "phone",
        header: "Phone",
        size: 150,
      },
      {
        accessorKey: "subject",
        header: "Subject",
        size: 150,
      },
      {
        accessorKey: "message",
        header: "Message",
        size: 250,
      },
      {
        accessorKey: "createdAt",
        header: "Date",
        size: 150,
        Cell: ({ cell }) => new Date(cell.getValue()).toLocaleString(),
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data,
    state: { isLoading },
    enableRowActions: false,
    enableColumnOrdering: true,
    enableGlobalFilter: true,
  });

  return (
    <Fragment>
      <Breadcrumbs mainTitle="Get In Touch" parent="Pages" title="Get In Touch" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <MaterialReactTable table={table} />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default GetInTouch;
